export const {
  REACT_APP_FIREBASE_API_KEY: API_KEY = '',
  REACT_APP_AUTH_DOMAIN: AUTH_DOMAIN = '',
  REACT_APP_PROJECT_ID: PROJECT_ID = '',
  REACT_APP_STORAGE_BUCKET: STORAGE_BUCKET = '',
  REACT_APP_SENDER_ID: SENDER_ID = '',
  REACT_APP_APP_ID: APP_ID = '',
  REACT_APP_MEASUREMENT_ID: MEASUREMENT_ID = ''
} = process.env
